import { Weblog } from '@ks/weblogger';
import { getCookie } from '../utils/cookie';
import dayjs from 'dayjs';
import store from '@/store';
import { invoke } from '@yoda/bridge';
import Radar from '@ks-radar/radar';


export const weblog = new Weblog({
    env: process.env.NODE_ENV,
    autoPV: false,
    fps: false,
    timing: false,
    proto: 'v3',
    yoda: { invoke },
}, {
    user_id: getCookie('userId') || getCookie('ud'),
    product_name: 'kuaishou_CSC', // APP分析可以搞起了～
});

export const radar = new Radar({
    weblog: weblog,
    projectId: '5f8e7c6102',
    sampling: 1, // 上报采样率，1 为全部上报
});


// 事件类型
export const customType = {
    Api: 'api',
    Pv: 'pv',
    Performance: 'performance',
    Upload: 'upload',
    Click: 'click',
    Custom: 'custom',
    UserTrace: 'userTrace', // 用户轨迹
};
export const resultType = {
    Success: 'success',
    Fail: 'fail',
    Fending: 'pending',
    Unset: '',
};
export const apiCategoty = {
    network: 'network',
    biz: 'biz',
    request: 'request',
    success: 'success',
};
export const performanceCatetory = {
    api: 'api',
};
export const pointCategory = {
    Pv: 'pv',
    Click: 'click',
    Show: 'show',
};

function getCustomLogParams() {
    let kfx_version = '';
    if (window.kfxEnv && window.kfxEnv.version) {
        kfx_version = window.kfxEnv.version;
    }
    return {
        kfx_version,
    };
}
export const customLog = function (params) {
    try {
        const name = 'web_custom';
        const { type, extra, result = resultType.Unset, category = '', message = '' } = params;
        radar.event({
            name,
            event_type: type,
            category,
            message,
            result_type: result,
            extra_info: JSON.stringify({
                ...getCustomLogParams(),
                biz_key: store.state.currentBizKey,
                page_key: store.state.routerPageKey || '',
                from_key: store.state.from || '',
                localTimeStr: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                version: process.env.VUE_APP_SENTRY_RELEASE,
                pageUrl: window.location.href,
                chanel: '信息收集collect',
                ...extra,
            }),
        });
    } catch (err) {
        //
    }
};

// 关于这个方法的封装其实我也拿不准，看了好几个项目都各异……
// 目前先保留这几个参数好了，入参用对象形式是为了预防未来参数越加越多
export const sendPVOld = ({ page, params, contentPackage } = {}) => {
    // console.log(page, params, contentPackage);
    // PV还是即时发送保险点
    weblog && weblog.sendImmediately('PV', {
        type: 'enter',
        page,
        params,
        contentPackage,
    });
};

export const sendPV = function (page, type = 'enter', params = {}) {
    weblog && weblog.sendImmediately('PV', {
        type,
        page,
        params,
    });
    weblog && customLog({
        type: customType.UserTrace,
        category: pointCategory.Pv,
        extra: {
            type,
            ...params,
            pageName: page,
        },
    });
};

export const sendClickImmediately = function (action, params = {}) {
    weblog && weblog.sendImmediately('CLICK', action, params);
    weblog && customLog({
        type: customType.UserTrace,
        category: pointCategory.Click,
        extra: {
            ...params,
            actionName: action,
        },
    });
};

export const sendShowImmediately = function (name, params = {}) {
    weblog && weblog.sendImmediately('SHOW', name, params);
    weblog && customLog({
        type: customType.UserTrace,
        category: pointCategory.Show,
        extra: {
            ...params,
            elementName: name,
        },
    });
};
